import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  cart: [],
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const existingItem = state.cart.find(item => item.pickleId === action.payload.pickleId);
      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.cart.push(action.payload);
      }
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item.pickleId !== action.payload);
    },
    updateCartQuantity: (state, action) => {
      const item = state.cart.find(item => item.pickleId === action.payload.pickleId);
      if (item) {
        item.quantity = action.payload.quantity;
      }
    },
    clearCart: (state) => {
      state.cart = [];
    },
    fetchOrdersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrdersSuccess: (state, action) => {
      state.loading = false;
      state.orders = action.payload;
      state.error = null;
    },
    fetchOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createOrderRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createOrderSuccess: (state, action) => {
      state.loading = false;
      state.orders.unshift(action.payload);
      state.cart = [];
      state.error = null;
    },
    createOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateOrderStatusRequest: (state) => {
      state.loading = true;
    },
    // updateOrderStatusSuccess: (state, action) => {
    //   state.loading = false;
    //   const index = state.orders.findIndex(o => o.id === action.payload.id);
    //   if (index !== -1) {
    //     state.orders[index] = action.payload;
    //   }
    // },
    updateOrderStatusSuccess: (state, action) => {
  state.loading = false;
  const { id, status } = action.payload;

  const order = state.orders.find(o => o.id === id);
  if (order) {
    order.status = status; // ✅ correct update
  }
},
    updateOrderStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  updateCartQuantity,
  clearCart,
  fetchOrdersRequest,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  createOrderRequest,
  createOrderSuccess,
  createOrderFailure,
  updateOrderStatusRequest,
  updateOrderStatusSuccess,
  updateOrderStatusFailure,
} = orderSlice.actions;

export default orderSlice.reducer;